import React from 'react'
import {FieldFormElementProps} from "../../../../render/form-elemnent";
import FieldTimeOfDay_FormElementView from "./form-element-view";

const debug = false
// const debug = "FieldTimeOfDay_FormView"

export default function FieldTimeOfDay_FormElement(props:FieldFormElementProps) {

    const onChange = (value: Moment) => {

        if (props.form) {
            props.form.onFormComponentValueChange(props.field.fieldId, value)
        }
    }

    return (
        <FieldTimeOfDay_FormElementView  field     = {props.field}
                                         model     = {props.model}
                                         onChange  = {onChange}
                                         className = {props.className} />
    )

}
